<template>
  <div>
      <b-sidebar id="sidebar-right" :title="title" right shadow backdrop v-model="sideBarShow">
        <b-card>
          <b-button variant="outline-primary" :style="{marginBottom: '18px'}" @click="authApp()" >添加授权</b-button>
          <b-table responsive="sm" :items="items" :fields="fields" :current-page="currentPage" >
            <template #cell(op)="data">
              <b-button v-if="$store.getters.loginInfo.name !== data.item.name" size="sm" variant="outline-danger" @click="cancelAuth(data.index)" >取消授权</b-button>
            </template>
          </b-table>
          <nav>
            <b-pagination
              :total-rows="totalRows"
              :per-page="perPage"
              v-model="currentPage"
              prev-text="<<"
              next-text=">>"
              @change="changePage"
              hide-goto-end-buttons
              first-number
              last-number
            />
          </nav>
        </b-card>
      </b-sidebar>
      <VoteAuth ref="authModal" @refreshList="refresh($event)" />
  </div>
</template>

<script>
import Error from '@/mixin/error'
import api from '@/utils/api'
import consts from '@/utils/consts'
import VoteAuth from '@/components/Vote/VoteAuth'

export default {
  name: 'vote-auth-list',
  mixins: [Error],
  components: {VoteAuth},
  data () {
    return {
      sideBarShow: false,
      title: '',
      fields: consts.VOTE_AUTH_FIELDS,
      items: [],
      totalRows: null,
      currentPage: 1,
      perPage: 10,
      appId: null,
      appName: null,
      oversea: null
    }
  },
  methods: {
    show (appId, appName, oversea) {
      this.appId = appId
      this.appName = appName
      this.oversea = oversea
      this.sideBarShow = true
      this.title = appName
      this.getAuthList(appId)
    },
    changePage (page) {
      this.currentPage = page
      this.getAuthList(this.appId)
    },
    getAuthList (appId) {
      api.fetchListData(this, api.getVoteAdminList(), 'admin_info', { app_id: appId, edition: this.oversea ? consts.OVERSEA_TYPE : process.env.NODE_ENV.slice(0, 3) }, this.handleUserList)
    },
    handleUserList (resData) {
      let items = []
      for (let idx in resData['admin_info']) {
        if (resData['admin_info'][idx].is_bd) {
          items.push({
            name: resData['admin_info'][idx].name,
            email: resData['admin_info'][idx].email
          })
        }
      }
      this.items = items
      this.totalRows = resData.total_num
    },
    authApp () {
      this.$refs.authModal.show(this.appId, this.oversea)
    },
    refresh (appId) {
      this.getAuthList(appId)
    },
    cancelAuth (idx) {
      let data = {
        email_list: [this.items[idx].email],
        app_id: this.appId
      }
      api.updateVoteData(this, api.getVoteAppUnFocus(), 'GET', data, this.oversea ? consts.OVERSEA_TYPE : '', this.cancelAuthCallback, false)
    },
    cancelAuthCallback () {
      this.$message.info('取消授权成功')
      this.refresh(this.appId)
    }
  }
}
</script>

<style lang="css">
  .b-sidebar {
    width: 25% !important;
  }
</style>



// WEBPACK FOOTER //
// VoteAuthList.vue?27d92580